import { Observable } from 'rxjs';
import GenericService from 'services/genericService';
import { Activities } from 'utils/api/models/activities/activities';
import { getInteractionDetails, getInteractions, getInteractionsCsv } from 'utils/api/queries/microApi';
import * as payloads from 'utils/api/payloads/microApi';
import { InteractionDetailsResponse } from 'utils/api/models/activities/interactionDetailsResponse';

export class ActivitiesService extends GenericService {
	public static getInteractions(data: payloads.GetInteractions): Observable<Activities> {
		return getInteractions(data)
			.withErrorHandling()
			.call();
	}

	public static getInteractionsCsv(data: payloads.GetInteractions): Observable<any> {
		return getInteractionsCsv(data)
			.withErrorHandling()
			.call();
	}

	public static getInteractionDetails(interactionId: number): Observable<InteractionDetailsResponse> {
		return getInteractionDetails(interactionId)
			.withErrorHandling()
			.call();
	}
}
